import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { media } from "../../styles/breakpoints";

const Image = styled.img`
  margin-bottom: 20px;
  border-radius: ${(props) => (props.rounded ? "10%" : "0px")};
  width: clamp(200px, 82vw, 350px);
  max-height: clamp(100px, 41vw, 175px);
  object-fit: contain;

  ${media.md`
    width: clamp(280px, 36vw, 350px);
    max-height: clamp(140px, 18vw, 175px);
  `}

  ${media.lg`
    width: 350px;
    max-height: 175px;
  `}
`;

const propTypes = {
  src: PropTypes.string.isRequired,
  rounded: PropTypes.bool,
};

function Logo({ src, rounded }) {
  return <Image rounded src={src} />;
}

Logo.propTypes = propTypes;

export default Logo;
